<template>
    <div class="ma-4">
        <ClientNav/>
        <v-row dense>
            <v-col cols="12">
                <v-spacer></v-spacer>
                <v-card>
                    <v-card-title style="background-color: #2b3990">
                        <span class="headline white--text">{{ titleForm }}</span>
                    </v-card-title>
                    <v-card-text>
                        <v-layout row wrap>
                            <v-flex xs12 class="pa-4">
                                <v-layout row wrap>
                                    <v-flex xs12 class="pa-2">
                                        <v-card-subtitle>
                                            Purpose of this checklist is to ensure that
                                            Redhead Supports Management is completing its due
                                            diligence regarding the discharge of a client.
                                        </v-card-subtitle>
                                    </v-flex>
                                    <v-flex xs4 class="pa-2">
                                        <v-menu
                                            ref="menu"
                                            v-model="menu"
                                            :close-on-content-click="false"
                                            :return-value.sync="date"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="auto"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field
                                                    v-model="DischargeDate"
                                                    label="Assessment Date"
                                                    prepend-icon="mdi-calendar"
                                                    readonly
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    clearable
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                v-model="DischargeDate"
                                                no-title
                                                scrollable
                                            >
                                                <v-spacer></v-spacer>
                                                <v-btn
                                                    text
                                                    color="primary"
                                                    @click="menu = false"
                                                >
                                                    Cancel
                                                </v-btn>
                                                <v-btn
                                                    text
                                                    color="primary"
                                                    @click="$refs.menu.save(date)"
                                                >
                                                    OK
                                                </v-btn>
                                            </v-date-picker>
                                        </v-menu>
                                    </v-flex>
                                    <v-flex xs4 class="pa-2">
                                        <v-text-field
                                            label="Client Name"
                                            readonly
                                            v-model="ClientName"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs4 class="pa-2">
                                        <v-text-field
                                            label="Location"
                                            v-model="Location"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-card-title>Items to Verify</v-card-title>
                                        <v-divider class="ma-2"></v-divider>
                                    </v-flex>

                                    <v-flex xs6 class="pa-2">
                                        <v-checkbox
                                            label="ID Returned?"
                                            value="Yes"
                                            v-model="Identification.Returned"
                                        ></v-checkbox>
                                    </v-flex>

                                    <v-flex
                                        xs6
                                        v-if="Identification.Returned != 'Yes'"
                                    ></v-flex>

                                    <v-flex
                                        xs6
                                        class="pa-2"
                                        v-if="Identification.Returned == 'Yes'"
                                    >
                                        <v-checkbox
                                            label="Click to Sign"
                                            v-model="IDSigned"
                                            @click="addIDSignature()"
                                        ></v-checkbox>
                                    </v-flex>
                                    <v-flex xs12 class="pa-2" v-if="IDSigned">
                                        <v-text-field
                                            label="ID Return Verified By"
                                            v-model="Identification.VerifiedBy"
                                        ></v-text-field>
                                    </v-flex>

                                    <v-flex xs6 class="pa-2">
                                        <v-checkbox
                                            label="Social Security Card Returned?"
                                            value="Yes"
                                            v-model="Social.Returned"
                                        ></v-checkbox>
                                    </v-flex>

                                    <v-flex xs6 v-if="Social.Returned != 'Yes'"></v-flex>

                                    <v-flex
                                        xs6
                                        class="pa-2"
                                        v-if="Social.Returned == 'Yes'"
                                    >
                                        <v-checkbox
                                            label="Click to Sign"
                                            v-model="SocialSigned"
                                            @click="addSocialSignature()"
                                        ></v-checkbox>
                                    </v-flex>
                                    <v-flex xs12 class="pa-2" v-if="SocialSigned">
                                        <v-text-field
                                            label="Social Security Card Return Verified By"
                                            v-model="Social.VerifiedBy"
                                        ></v-text-field>
                                    </v-flex>

                                    <v-flex xs6 class="pa-2">
                                        <v-checkbox
                                            label="Medicaid Card Returned?"
                                            value="Yes"
                                            v-model="Medicaid.Returned"
                                        ></v-checkbox>
                                    </v-flex>

                                    <v-flex
                                        xs6
                                        v-if="Medicaid.Returned != 'Yes'"
                                    ></v-flex>

                                    <v-flex
                                        xs6
                                        class="pa-2"
                                        v-if="Medicaid.Returned == 'Yes'"
                                    >
                                        <v-checkbox
                                            label="Click to Sign"
                                            v-model="MedicaidSigned"
                                            @click="addMedicaidSignature()"
                                        ></v-checkbox>
                                    </v-flex>
                                    <v-flex xs12 class="pa-2" v-if="MedicaidSigned">
                                        <v-text-field
                                            label="Medicaid Card Return Verified By"
                                            v-model="Medicaid.VerifiedBy"
                                        ></v-text-field>
                                    </v-flex>

                                    <v-flex xs6 class="pa-2">
                                        <v-checkbox
                                            label="Other Insurance Returned?"
                                            value="Yes"
                                            v-model="Insurance.Returned"
                                        ></v-checkbox>
                                    </v-flex>

                                    <v-flex
                                        xs8
                                        v-if="Insurance.Returned != 'Yes'"
                                    ></v-flex>

                                    <v-flex
                                        xs6
                                        class="pa-2"
                                        v-if="Insurance.Returned == 'Yes'"
                                    >
                                        <v-checkbox
                                            label="Click to Sign"
                                            v-model="InsuranceSigned"
                                            @click="addInsuranceSignature()"
                                        ></v-checkbox>
                                    </v-flex>
                                    <v-flex xs12 class="pa-2" v-if="InsuranceSigned">
                                        <v-text-field
                                            label="Insurance Return Verified By"
                                            v-model="Insurance.VerifiedBy"
                                        ></v-text-field>
                                    </v-flex>

                                    <v-flex xs6 class="pa-2">
                                        <v-checkbox
                                            label="EBT Card Returned?"
                                            value="Yes"
                                            v-model="EBT.Returned"
                                        ></v-checkbox>
                                    </v-flex>

                                    <v-flex xs8 v-if="EBT.Returned != 'Yes'"></v-flex>

                                    <v-flex xs6 class="pa-2" v-if="EBT.Returned == 'Yes'">
                                        <v-checkbox
                                            label="Click to Sign"
                                            v-model="EBTSigned"
                                            @click="addEBTSignature()"
                                        ></v-checkbox>
                                    </v-flex>
                                    <v-flex xs12 class="pa-2" v-if="EBTSigned">
                                        <v-text-field
                                            label="EBT Card Return Verified By"
                                            v-model="EBT.VerifiedBy"
                                        ></v-text-field>
                                    </v-flex>

                                    <v-flex xs6 class="pa-2">
                                        <v-checkbox
                                            label="Medication List Printed?"
                                            value="Yes"
                                            v-model="Medication.Printed"
                                        ></v-checkbox>
                                    </v-flex>

                                    <v-flex
                                        xs8
                                        v-if="Medication.Printed != 'Yes'"
                                    ></v-flex>

                                    <v-flex
                                        xs6
                                        class="pa-2"
                                        v-if="Medication.Printed == 'Yes'"
                                    >
                                        <v-checkbox
                                            label="Click to Sign"
                                            v-model="MedicationSigned"
                                            @click="addMedicationSignature()"
                                        ></v-checkbox>
                                    </v-flex>
                                    <v-flex xs12 class="pa-2" v-if="MedicationSigned">
                                        <v-text-field
                                            label="Medication Print Verified By"
                                            v-model="Medication.VerifiedBy"
                                        ></v-text-field>
                                    </v-flex>

                                    <v-flex xs6 class="pa-2">
                                        <v-checkbox
                                            label="List of Doctors Printed?"
                                            value="Yes"
                                            v-model="Doctors.Printed"
                                        ></v-checkbox>
                                    </v-flex>

                                    <v-flex xs8 v-if="Doctors.Printed != 'Yes'"></v-flex>

                                    <v-flex
                                        xs6
                                        class="pa-2"
                                        v-if="Doctors.Printed == 'Yes'"
                                    >
                                        <v-checkbox
                                            label="Click to Sign"
                                            v-model="DoctorsSigned"
                                            @click="addDoctorsSignature()"
                                        ></v-checkbox>
                                    </v-flex>
                                    <v-flex xs12 class="pa-2" v-if="DoctorsSigned">
                                        <v-text-field
                                            label="List of Doctors Printed Verified By"
                                            v-model="Doctors.VerifiedBy"
                                        ></v-text-field>
                                    </v-flex>

                                    <v-flex xs6 class="pa-2">
                                        <v-checkbox
                                            label="Social Assessment Printed?"
                                            value="Yes"
                                            v-model="SocialAssessment.Printed"
                                        ></v-checkbox>
                                    </v-flex>

                                    <v-flex
                                        xs8
                                        v-if="SocialAssessment.Printed != 'Yes'"
                                    ></v-flex>

                                    <v-flex
                                        xs6
                                        class="pa-2"
                                        v-if="SocialAssessment.Printed == 'Yes'"
                                    >
                                        <v-checkbox
                                            label="Click to Sign"
                                            v-model="SocialAssessmentSigned"
                                            @click="addSocialAssessmentSignature()"
                                        ></v-checkbox>
                                    </v-flex>
                                    <v-flex
                                        xs12
                                        class="pa-2"
                                        v-if="SocialAssessmentSigned"
                                    >
                                        <v-text-field
                                            label="Social Assessment Verified By"
                                            v-model="SocialAssessment.VerifiedBy"
                                        ></v-text-field>
                                    </v-flex>

                                    <v-flex xs6 class="pa-2">
                                        <v-checkbox
                                            label="Psych Eval Printed?"
                                            value="Yes"
                                            v-model="Psych.Printed"
                                        ></v-checkbox>
                                    </v-flex>

                                    <v-flex xs8 v-if="Psych.Printed != 'Yes'"></v-flex>

                                    <v-flex
                                        xs6
                                        class="pa-2"
                                        v-if="Psych.Printed == 'Yes'"
                                    >
                                        <v-checkbox
                                            label="Click to Sign"
                                            v-model="PsychSigned"
                                            @click="addPsychSignature()"
                                        ></v-checkbox>
                                    </v-flex>
                                    <v-flex xs12 class="pa-2" v-if="PsychSigned">
                                        <v-text-field
                                            label="Psych Eval Print Verified By"
                                            v-model="Psych.VerifiedBy"
                                        ></v-text-field>
                                    </v-flex>

                                    <v-flex xs6 class="pa-2">
                                        <v-checkbox
                                            label="Behavior Support Plan Printed?"
                                            value="Yes"
                                            v-model="BehaviorPlan.Printed"
                                        ></v-checkbox>
                                    </v-flex>

                                    <v-flex
                                        xs8
                                        v-if="BehaviorPlan.Printed != 'Yes'"
                                    ></v-flex>

                                    <v-flex
                                        xs6
                                        class="pa-2"
                                        v-if="BehaviorPlan.Printed == 'Yes'"
                                    >
                                        <v-checkbox
                                            label="Click to Sign"
                                            v-model="BehaviorPlanSigned"
                                            @click="addBehaviorPlanSignature()"
                                        ></v-checkbox>
                                    </v-flex>
                                    <v-flex xs12 class="pa-2" v-if="BehaviorPlanSigned">
                                        <v-text-field
                                            label="Behavior Plan Print Verified By"
                                            v-model="BehaviorPlan.VerifiedBy"
                                        ></v-text-field>
                                    </v-flex>

                                    <v-flex xs6 class="pa-2">
                                        <v-checkbox
                                            label="Climate Client Account Discharged?"
                                            value="Yes"
                                            v-model="Account.Discharged"
                                        ></v-checkbox>
                                    </v-flex>

                                    <v-flex
                                        xs8
                                        v-if="Account.Discharged != 'Yes'"
                                    ></v-flex>

                                    <v-flex
                                        xs6
                                        class="pa-2"
                                        v-if="Account.Discharged == 'Yes'"
                                    >
                                        <v-checkbox
                                            label="Click to Sign"
                                            v-model="AccountSigned"
                                            @click="addAccountSignature()"
                                        ></v-checkbox>
                                    </v-flex>
                                    <v-flex xs12 class="pa-2" v-if="AccountSigned">
                                        <v-text-field
                                            label="Account Discharge Verified By"
                                            v-model="Account.VerifiedBy"
                                        ></v-text-field>
                                    </v-flex>

                                    <v-flex xs6 class="pa-2">
                                        <v-checkbox
                                            label="Shifts Disabled?"
                                            value="Yes"
                                            v-model="Shifts.Disabled"
                                        ></v-checkbox>
                                    </v-flex>

                                    <v-flex xs8 v-if="Shifts.Disabled != 'Yes'"></v-flex>

                                    <v-flex
                                        xs6
                                        class="pa-2"
                                        v-if="Shifts.Disabled == 'Yes'"
                                    >
                                        <v-checkbox
                                            label="Click to Sign"
                                            v-model="ShiftsSigned"
                                            @click="addShiftSignature()"
                                        ></v-checkbox>
                                    </v-flex>
                                    <v-flex xs12 class="pa-2" v-if="ShiftsSigned">
                                        <v-text-field
                                            label="Shifts Diabled Verified By"
                                            v-model="Shifts.VerifiedBy"
                                        ></v-text-field>
                                    </v-flex>

                                    <v-flex xs6 class="pa-2">
                                        <v-checkbox
                                            label="Pharmacy Notified?"
                                            value="Yes"
                                            v-model="Pharmacy.Notified"
                                        ></v-checkbox>
                                    </v-flex>

                                    <v-flex
                                        xs8
                                        v-if="Pharmacy.Notified != 'Yes'"
                                    ></v-flex>

                                    <v-flex
                                        xs6
                                        class="pa-2"
                                        v-if="Pharmacy.Notified == 'Yes'"
                                    >
                                        <v-checkbox
                                            label="Click to Sign"
                                            v-model="PharmacySigned"
                                            @click="addPharmacySignature()"
                                        ></v-checkbox>
                                    </v-flex>
                                    <v-flex xs12 class="pa-2" v-if="PharmacySigned">
                                        <v-text-field
                                            label="Pharmacy Notified Verified By"
                                            v-model="Pharmacy.VerifiedBy"
                                        ></v-text-field>
                                    </v-flex>

                                    <v-flex xs6 class="pa-2">
                                        <v-checkbox
                                            label="Inventory Printed/Verified?"
                                            value="Yes"
                                            v-model="Inventory.Printed"
                                        ></v-checkbox>
                                    </v-flex>

                                    <v-flex
                                        xs8
                                        v-if="Inventory.Printed != 'Yes'"
                                    ></v-flex>

                                    <v-flex
                                        xs6
                                        class="pa-2"
                                        v-if="Inventory.Printed == 'Yes'"
                                    >
                                        <v-checkbox
                                            label="Click to Sign"
                                            v-model="InventorySigned"
                                            @click="addInventorySignature()"
                                        ></v-checkbox>
                                    </v-flex>
                                    <v-flex xs12 class="pa-2" v-if="InventorySigned">
                                        <v-text-field
                                            label="Inventory Printed Verified By"
                                            v-model="Inventory.VerifiedBy"
                                        ></v-text-field>
                                    </v-flex>

                                    <v-flex xs6 class="pa-2">
                                        <v-checkbox
                                            label="Meds Discontinued?"
                                            value="Yes"
                                            v-model="Meds.Discontinued"
                                        ></v-checkbox>
                                    </v-flex>

                                    <v-flex
                                        xs8
                                        v-if="Meds.Discontinued != 'Yes'"
                                    ></v-flex>

                                    <v-flex
                                        xs6
                                        class="pa-2"
                                        v-if="Meds.Discontinued == 'Yes'"
                                    >
                                        <v-checkbox
                                            label="Click to Sign"
                                            v-model="MedsSigned"
                                            @click="addMedsSignature()"
                                        ></v-checkbox>
                                    </v-flex>
                                    <v-flex xs12 class="pa-2" v-if="MedsSigned">
                                        <v-text-field
                                            label="Meds Disabled Verified By"
                                            v-model="Meds.VerifiedBy"
                                        ></v-text-field>
                                    </v-flex>

                                    <v-flex xs6 class="pa-2">
                                        <v-checkbox
                                            label="Service Plan Deactivated?"
                                            value="Yes"
                                            v-model="ServicePlan.Deactivated"
                                        ></v-checkbox>
                                    </v-flex>

                                    <v-flex
                                        xs8
                                        v-if="ServicePlan.Deactivated != 'Yes'"
                                    ></v-flex>

                                    <v-flex
                                        xs6
                                        class="pa-2"
                                        v-if="ServicePlan.Deactivated == 'Yes'"
                                    >
                                        <v-checkbox
                                            label="Click to Sign"
                                            v-model="ServicePlanSigned"
                                            @click="addServicePlanSignature()"
                                        ></v-checkbox>
                                    </v-flex>
                                    <v-flex xs12 class="pa-2" v-if="ServicePlanSigned">
                                        <v-text-field
                                            label="Service Plan Verified By"
                                            v-model="ServicePlan.VerifiedBy"
                                        ></v-text-field>
                                    </v-flex>

                                    <v-flex xs6 class="pa-2">
                                        <v-checkbox
                                            label="Paycard/Debit Card Closed with Client Finance?"
                                            value="Yes"
                                            v-model="Finance.Closed"
                                        ></v-checkbox>
                                    </v-flex>

                                    <v-flex xs8 v-if="Finance.Closed != 'Yes'"></v-flex>

                                    <v-flex
                                        xs6
                                        class="pa-2"
                                        v-if="Finance.Closed == 'Yes'"
                                    >
                                        <v-checkbox
                                            label="Click to Sign"
                                            v-model="FinanceSigned"
                                            @click="addFinanceSignature()"
                                        ></v-checkbox>
                                    </v-flex>
                                    <v-flex xs12 class="pa-2" v-if="FinanceSigned">
                                        <v-text-field
                                            label="Finance Closed Verified By"
                                            v-model="Finance.VerifiedBy"
                                        ></v-text-field>
                                    </v-flex>

                                    <v-flex xs6 class="pa-2">
                                        <v-checkbox
                                            label="If Attending Day Program, Were They Notified?"
                                            value="Yes"
                                            v-model="DayProgram.Notified"
                                        ></v-checkbox>
                                    </v-flex>

                                    <v-flex
                                        xs8
                                        v-if="DayProgram.Notified != 'Yes'"
                                    ></v-flex>

                                    <v-flex
                                        xs6
                                        class="pa-2"
                                        v-if="DayProgram.Notified == 'Yes'"
                                    >
                                        <v-checkbox
                                            label="Click to Sign"
                                            v-model="DayProgramSigned"
                                            @click="addDayProgramSignature()"
                                        ></v-checkbox>
                                    </v-flex>
                                    <v-flex xs12 class="pa-2" v-if="DayProgramSigned">
                                        <v-text-field
                                            label="Day Program Verified By"
                                            v-model="DayProgram.VerifiedBy"
                                        ></v-text-field>
                                    </v-flex>

                                    <v-flex xs6 class="pa-2">
                                        <v-checkbox
                                            label="If Attending School, Have They Been Notified?"
                                            value="Yes"
                                            v-model="School.Notified"
                                        ></v-checkbox>
                                    </v-flex>

                                    <v-flex xs8 v-if="School.Notified != 'Yes'"></v-flex>

                                    <v-flex
                                        xs6
                                        class="pa-2"
                                        v-if="School.Notified == 'Yes'"
                                    >
                                        <v-checkbox
                                            label="Click to Sign"
                                            v-model="SchoolSigned"
                                            @click="addSchoolSignature()"
                                        ></v-checkbox>
                                    </v-flex>
                                    <v-flex xs12 class="pa-2" v-if="SchoolSigned">
                                        <v-text-field
                                            label="School Notified Verified By"
                                            v-model="School.VerifiedBy"
                                        ></v-text-field>
                                    </v-flex>

                                    <v-flex xs6 class="pa-2">
                                        <v-checkbox
                                            label="House Staff Notified?"
                                            value="Yes"
                                            v-model="Staff.Notified"
                                        ></v-checkbox>
                                    </v-flex>

                                    <v-flex xs8 v-if="Staff.Notified != 'Yes'"></v-flex>

                                    <v-flex
                                        xs6
                                        class="pa-2"
                                        v-if="Staff.Notified == 'Yes'"
                                    >
                                        <v-checkbox
                                            label="Click to Sign"
                                            v-model="StaffSigned"
                                            @click="addStaffSignature()"
                                        ></v-checkbox>
                                    </v-flex>
                                    <v-flex xs12 class="pa-2" v-if="StaffSigned">
                                        <v-text-field
                                            label="House Staff Notified Verified By"
                                            v-model="Staff.VerifiedBy"
                                        ></v-text-field>
                                    </v-flex>

                                    <v-flex xs6 class="pa-2">
                                        <v-checkbox
                                            label="Behaviorist Notified?"
                                            value="Yes"
                                            v-model="Behaviorist.Notified"
                                        ></v-checkbox>
                                    </v-flex>

                                    <v-flex
                                        xs8
                                        v-if="Behaviorist.Notified != 'Yes'"
                                    ></v-flex>

                                    <v-flex
                                        xs6
                                        class="pa-2"
                                        v-if="Behaviorist.Notified == 'Yes'"
                                    >
                                        <v-checkbox
                                            label="Click to Sign"
                                            v-model="BehavioristSigned"
                                            @click="addBehavioristSignature()"
                                        ></v-checkbox>
                                    </v-flex>
                                    <v-flex xs12 class="pa-2" v-if="BehavioristSigned">
                                        <v-text-field
                                            label="Behaviorist Notified Verified By"
                                            v-model="Behaviorist.VerifiedBy"
                                        ></v-text-field>
                                    </v-flex>

                                    <v-flex xs6 class="pa-2">
                                        <v-checkbox
                                            label="Medical Notified of Discharge?"
                                            value="Yes"
                                            v-model="Medical.Notified"
                                        ></v-checkbox>
                                    </v-flex>

                                    <v-flex xs8 v-if="Medical.Notified != 'Yes'"></v-flex>

                                    <v-flex
                                        xs6
                                        class="pa-2"
                                        v-if="Medical.Notified == 'Yes'"
                                    >
                                        <v-checkbox
                                            label="Click to Sign"
                                            v-model="MedicalSigned"
                                            @click="addMedicalSignature()"
                                        ></v-checkbox>
                                    </v-flex>
                                    <v-flex xs12 class="pa-2" v-if="MedicalSigned">
                                        <v-text-field
                                            label="Medical Notified Verified By"
                                            v-model="Medical.VerifiedBy"
                                        ></v-text-field>
                                    </v-flex>

                                    <v-flex xs12 class="pa-2">
                            <span
                            >Are there any outstanding issues to resolve or
                              additional information required?
                            </span>
                                        <v-textarea
                                            v-model="OutstandingInformation"
                                            outlined
                                            auto-grow
                                        ></v-textarea>
                                    </v-flex>
                                    <v-flex xs6 class="pa-2">
                                        <v-checkbox
                                            label="Client Services Signature"
                                            v-model="ClientServicesSigned"
                                            @click="addClientServicesSignature()"
                                        ></v-checkbox>
                                    </v-flex>

                                    <v-flex xs12 class="pa-2" v-if="ClientServicesSigned">
                                        <v-text-field
                                            label="Signature"
                                            v-model="ClientServicesSignature"
                                        ></v-text-field>
                                    </v-flex>

                                    <v-flex xs6 class="pa-2">
                                        <v-checkbox
                                            label="Compliance Manager Signature"
                                            v-model="ComplianceSigned"
                                            @click="addComplianceSignature()"
                                        ></v-checkbox>
                                    </v-flex>

                                    <v-flex xs12 class="pa-2" v-if="ComplianceSigned">
                                        <v-text-field
                                            label="Signature"
                                            v-model="ComplianceSignature"
                                        ></v-text-field>
                                    </v-flex>

                                    <!-- <v-flex xs12>
                                      <v-card-actions>
                                          <v-spacer></v-spacer>
                                          <v-btn @click="addDischarge()">Save</v-btn>
                                          <v-btn @click="updateDischarge()">Update</v-btn>
                                          <v-btn @click="clearDischarge()">Cancel</v-btn>
                                      </v-card-actions>
                                  </v-flex>                 -->
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            fab
                            small
                            @click="showPrintModal()"
                            class="mr-8 mb-2 white--text"
                            color="#2b6993"
                            elevation="4"
                            v-if="!createDischarge"
                        >
                            <v-icon>print</v-icon>
                        </v-btn>
                        <v-btn
                            class="white--text"
                            color="#259647"
                            @click="addDischarge()"
                            v-if="createDischarge"
                        >Save
                        </v-btn>
                        <v-btn
                            color="blue darken-1 white--text"
                            @click="updateDischarge()"
                            v-if="!createDischarge"
                        >Update
                        </v-btn
                        >
                        <v-btn color="blue darken-1" text @click="close"
                        >Cancel
                        </v-btn
                        >
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
        <Foot/>
    </div>
</template>
<script>
import axios from "axios";
import ClientNav from "../../../components/ClientNav";
import Foot from "../../../components/Footer";
import {mapActions} from "vuex";
import {displaySuccess, displayError} from "../../../service/notification-message.service";
import PrintUtil from "../../../../utils/print-util";

// import moment from 'moment'

const url = require("../../../client_config/config").url;

export default {
    components: {
        ClientNav,
        Foot,
    },
    data: function () {
        return {
            msg: false,
            date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
                .toISOString()
                .substr(0, 10),
            menu: false,
            search: "",
            text: "",
            clientID: this.$route.params.clientID,
            dischargeId: this.$route.params.id,
            token: localStorage.getItem('token'),
            userID: localStorage.getItem("userID"),
            tempData: [],
            discharges: [],
            discharge: {},
            titleForm: "New Client Discharge",
            IDSigned: false,
            SocialSigned: false,
            MedicaidSigned: false,
            InsuranceSigned: false,
            EBTSigned: false,
            MedicationSigned: false,
            DoctorsSigned: false,
            SocialAssessmentSigned: false,
            PsychSigned: false,
            BehaviorPlanSigned: false,
            AccountSigned: false,
            ShiftsSigned: false,
            PharmacySigned: false,
            InventorySigned: false,
            MedsSigned: false,
            ServicePlanSigned: false,
            FinanceSigned: false,
            DayProgramSigned: false,
            SchoolSigned: false,
            StaffSigned: false,
            BehavioristSigned: false,
            MedicalSigned: false,
            ClientServicesSigned: false,
            ComplianceSigned: false,
            signed: false,
            staff: localStorage.getItem("Name"),
            isLoading: true,
            requiredRules: [(v) => !!v || "This is required"],
            ClientName: "",
            DischargeDate: "",
            Location: "",
            Identification: {
                Returned: "",
                VerifiedBy: "",
            },
            Social: {
                Returned: "",
                VerifiedBy: "",
            },
            Medicaid: {
                Returned: "",
                VerifiedBy: "",
            },
            Insurance: {
                Returned: "",
                VerifiedBy: "",
            },
            EBT: {
                Returned: "",
                VerifiedBy: "",
            },
            Medication: {
                Printed: "",
                VerifiedBy: "",
            },
            Doctors: {
                Printed: "",
                VerifiedBy: "",
            },
            SocialAssessment: {
                Printed: "",
                VerifiedBy: "",
            },
            Psych: {
                Printed: "",
                VerifiedBy: "",
            },
            BehaviorPlan: {
                Printed: "",
                VerifiedBy: "",
            },
            Account: {
                Discharged: "",
                VerifiedBy: "",
            },
            Shifts: {
                Disabled: "",
                VerifiedBy: "",
            },
            Pharmacy: {
                Notified: "",
                VerifiedBy: "",
            },
            Inventory: {
                Printed: "",
                VerifiedBy: "",
            },
            Meds: {
                Discontinued: "",
                VerifiedBy: "",
            },
            ServicePlan: {
                Deactivated: "",
                VerifiedBy: "",
            },
            Finance: {
                Closed: "",
                VerifiedBy: "",
            },
            DayProgram: {
                Notified: "",
                VerifiedBy: "",
            },
            School: {
                Notified: "",
                VerifiedBy: "",
            },
            Staff: {
                Notified: "",
                VerifiedBy: "",
            },
            Behaviorist: {
                Notified: "",
                VerifiedBy: "",
            },
            Medical: {
                Notified: "",
                VerifiedBy: "",
            },
            OutstandingInformation: "",
            ClientServicesSignature: "",
            ComplianceSignature: "",
            dischargeID: "",
            createDischarge: false,
        };
    },

    computed: {},

    watch: {
        'Identification.Returned': function (newValue) {
            if (newValue !== 'Yes') {
                this.IDSigned = false;
                this.Identification.VerifiedBy = "";
            }
        },
        'Social.Returned': function (newValue) {
            if (newValue !== 'Yes') {
                this.SocialSigned = false;
                this.Social.VerifiedBy = "";
            }
        },
        'Medicaid.Returned': function (newValue) {
            if (newValue !== 'Yes') {
                this.MedicaidSigned = false;
                this.Medicaid.VerifiedBy = "";
            }
        },
        'Insurance.Returned': function (newValue) {
            if (newValue !== 'Yes') {
                this.InsuranceSigned = false;
                this.Insurance.VerifiedBy = "";
            }
        },
        'EBT.Returned': function (newValue) {
            if (newValue !== 'Yes') {
                this.EBTSigned = false;
                this.EBT.VerifiedBy = "";
            }
        },
        'Medication.Printed': function (newValue) {
            if (newValue !== 'Yes') {
                this.MedicationSigned = false;
                this.Medication.VerifiedBy = "";
            }
        },
        'Doctors.Printed': function (newValue) {
            if (newValue !== 'Yes') {
                this.DoctorsSigned = false;
                this.Doctors.VerifiedBy = "";
            }
        },
        'SocialAssessment.Printed': function (newValue) {
            if (newValue !== 'Yes') {
                this.SocialAssessmentSigned = false;
                this.SocialAssessment.VerifiedBy = "";
            }
        },
        'Psych.Printed': function (newValue) {
            if (newValue !== 'Yes') {
                this.PsychSigned = false;
                this.Psych.VerifiedBy = "";
            }
        },
        'BehaviorPlan.Printed': function (newValue) {
            if (newValue !== 'Yes') {
                this.BehaviorPlanSigned = false;
                this.BehaviorPlan.VerifiedBy = "";
            }
        },
        'Account.Discharged': function (newValue) {
            if (newValue !== 'Yes') {
                this.AccountSigned = false;
                this.Account.VerifiedBy = "";
            }
        },
        'Shifts.Disabled': function (newValue) {
            if (newValue !== 'Yes') {
                this.ShiftsSigned = false;
                this.Shifts.VerifiedBy = "";
            }
        },
        'Pharmacy.Notified': function (newValue) {
            if (newValue !== 'Yes') {
                this.PharmacySigned = false;
                this.Pharmacy.VerifiedBy = "";
            }
        },
        'Inventory.Printed': function (newValue) {
            if (newValue !== 'Yes') {
                this.InventorySigned = false;
                this.Inventory.VerifiedBy = "";
            }
        },
        'Meds.Discontinued': function (newValue) {
            if (newValue !== 'Yes') {
                this.MedsSigned = false;
                this.Meds.VerifiedBy = "";
            }
        },
        'ServicePlan.Deactivated': function (newValue) {
            if (newValue !== 'Yes') {
                this.ServicePlanSigned = false;
                this.ServicePlan.VerifiedBy = "";
            }
        },
        'Finance.Closed': function (newValue) {
            if (newValue !== 'Yes') {
                this.FinanceSigned = false;
                this.Finance.VerifiedBy = "";
            }
        },
        'DayProgram.Notified': function (newValue) {
            if (newValue !== 'Yes') {
                this.DayProgramSigned = false;
                this.DayProgram.VerifiedBy = "";
            }
        },
        'School.Notified': function (newValue) {
            if (newValue !== 'Yes') {
                this.SchoolSigned = false;
                this.School.VerifiedBy = "";
            }
        },
        'Staff.Notified': function (newValue) {
            if (newValue !== 'Yes') {
                this.StaffSigned = false;
                this.Staff.VerifiedBy = "";
            }
        },
        'Behaviorist.Notified': function (newValue) {
            if (newValue !== 'Yes') {
                this.BehavioristSigned = false;
                this.Behaviorist.VerifiedBy = "";
            }
        },
        'Medical.Notified': function (newValue) {
            if (newValue !== 'Yes') {
                this.MedicalSigned = false;
                this.Medical.VerifiedBy = "";
            }
        }

    },

    created() {
        this.createDischarge = this.$route.query.createDischarge === 'true';
        this.getDischarges();
        this.getClientInfo(this.clientID);
        this.ClientName = this.$store.state.clients.client.Name;
        console.log(this.ClientName + " name");
    },

    mounted() {
        if (!this.createDischarge) {
            this.getDischarge();
        }

        window.addEventListener('keydown', async (event) => {
            this.downloadUrl = await this.generateDownloadUrl();
            PrintUtil.handleKeydown(event, this.downloadUrl, this.dischargeId, this.token, 'Discharge');
        });
    },

    beforeDestroy() {
        window.removeEventListener('keydown', (event) => {
            PrintUtil.handleKeydown(event, this.downloadUrl, this.dischargeId, this.token, 'Discharge');
        });
    },

    methods: {
        ...mapActions({
            getClientInfo: "clients/getClient",
        }),

        initialize() {
            this.discharges = [];
        },

        validate() {
            return this.$refs.form.validate();
        },

        viewDischarge(item) {
            if (item.Identification.VerifiedBy) {
                this.IDSigned = true;
            }
            if (item.Social.VerifiedBy) {
                this.SocialSigned = true;
            }
            if (item.Medicaid.VerifiedBy) {
                this.MedicaidSigned = true;
            }
            if (item.Insurance.VerifiedBy) {
                this.InsuranceSigned = true;
            }
            if (item.EBT.VerifiedBy) {
                this.EBTSigned = true;
            }
            if (item.Medication.VerifiedBy) {
                this.MedicationSigned = true;
            }
            if (item.Doctors.VerifiedBy) {
                this.DoctorsSigned = true;
            }
            if (item.SocialAssessment.VerifiedBy) {
                this.SocialAssessmentSigned = true;
            }
            if (item.Psych.VerifiedBy) {
                this.PsychSigned = true;
            }
            if (item.BehaviorPlan.VerifiedBy) {
                this.BehaviorPlanSigned = true;
            }
            if (item.Account.VerifiedBy) {
                this.AccountSigned = true;
            }
            if (item.Shifts.VerifiedBy) {
                this.ShiftsSigned = true;
            }
            if (item.Pharmacy.VerifiedBy) {
                this.PharmacySigned = true;
            }
            if (item.Inventory.VerifiedBy) {
                this.InventorySigned = true;
            }
            if (item.Meds.VerifiedBy) {
                this.MedsSigned = true;
            }
            if (item.ServicePlan.VerifiedBy) {
                this.ServicePlanSigned = true;
            }
            if (item.Finance.VerifiedBy) {
                this.FinanceSigned = true;
            }
            if (item.DayProgram.VerifiedBy) {
                this.DayProgramSigned = true;
            }
            if (item.School.VerifiedBy) {
                this.SchoolSigned = true;
            }
            if (item.Staff.VerifiedBy) {
                this.StaffSigned = true;
            }
            if (item.Behaviorist.VerifiedBy) {
                this.BehavioristSigned = true;
            }
            if (item.Medical.VerifiedBy) {
                this.MedicalSigned = true;
            }
            if (item.ClientServicesSignature !== "") {
                this.ClientServicesSigned = true;
            }
            if (item.ComplianceSignature !== "") {
                this.ComplianceSigned = true;
            }

            this.titleForm = "Viewing Discharge";
            this.dialog = true;
            this.newDischarge = false;
            this.editDischarge = true;
            this.DischargeDate = item.DischargeDate;
            this.Location = item.Location;
            this.Identification.Returned = item.Identification.Returned;
            this.Identification.VerifiedBy = item.Identification.VerifiedBy;
            this.Social.Returned = item.Social.Returned;
            this.Social.VerifiedBy = item.Social.VerifiedBy;
            this.Medicaid.Returned = item.Medicaid.Returned;
            this.Medicaid.VerifiedBy = item.Medicaid.VerifiedBy;
            this.Insurance.Returned = item.Insurance.Returned;
            this.Insurance.VerifiedBy = item.Insurance.VerifiedBy;
            this.EBT.Returned = item.EBT.Returned;
            this.EBT.VerifiedBy = item.EBT.VerifiedBy;
            this.Medication.Printed = item.Medication.Printed;
            this.Medication.VerifiedBy = item.Medication.VerifiedBy;
            this.Doctors.Printed = item.Doctors.Printed;
            this.Doctors.VerifiedBy = item.Doctors.VerifiedBy;
            this.SocialAssessment.Printed = item.SocialAssessment.Printed;
            this.SocialAssessment.VerifiedBy = item.SocialAssessment.VerifiedBy;
            this.Psych.Printed = item.Psych.Printed;
            this.Psych.VerifiedBy = item.Psych.VerifiedBy;
            this.BehaviorPlan.Printed = item.BehaviorPlan.Printed;
            this.BehaviorPlan.VerifiedBy = item.BehaviorPlan.VerifiedBy;
            this.Account.Discharged = item.Account.Discharged;
            this.Account.VerifiedBy = item.Account.VerifiedBy;
            this.Shifts.Disabled = item.Shifts.Disabled;
            this.Shifts.VerifiedBy = item.Shifts.VerifiedBy;
            this.Pharmacy.Notified = item.Pharmacy.Notified;
            this.Pharmacy.VerifiedBy = item.Pharmacy.VerifiedBy;
            this.Inventory.Printed = item.Inventory.Printed;
            this.Inventory.VerifiedBy = item.Inventory.VerifiedBy;
            this.Meds.Discontinued = item.Meds.Discontinued;
            this.Meds.VerifiedBy = item.Meds.VerifiedBy;
            this.ServicePlan.Deactivated = item.ServicePlan.Deactivated;
            this.ServicePlan.VerifiedBy = item.ServicePlan.VerifiedBy;
            this.Finance.Closed = item.Finance.Closed;
            this.Finance.VerifiedBy = item.Finance.VerifiedBy;
            this.DayProgram.Notified = item.DayProgram.Notified;
            this.DayProgram.VerifiedBy = item.DayProgram.VerifiedBy;
            this.School.Notified = item.School.Notified;
            this.School.VerifiedBy = item.School.VerifiedBy;
            this.Staff.Notified = item.Staff.Notified;
            this.Staff.VerifiedBy = item.Staff.VerifiedBy;
            this.Behaviorist.Notified = item.Behaviorist.Notified;
            this.Behaviorist.VerifiedBy = item.Behaviorist.VerifiedBy;
            this.Medical.Notified = item.Medical.Notified;
            this.Medical.VerifiedBy = item.Medical.VerifiedBy;
            (this.OutstandingInformation = item.OutstandingInformation),
                (this.ClientServicesSignature = item.ClientServicesSignature),
                (this.ComplianceSignature = item.ComplianceSignature),
                (this.dischargeID = item._id);
        },

        close() {
            this.clear();
            this.$router.go(-1);
        },

        async updateDischarge() {
            let req_body = {
                DischargeDate: this.DischargeDate,
                ClientID: this.clientID,
                Location: this.Location,
                Identification: {
                    Returned: this.Identification.Returned ?? "No",
                    VerifiedBy: this.Identification.VerifiedBy,
                },
                Social: {
                    Returned: this.Social.Returned ?? "No",
                    VerifiedBy: this.Social.VerifiedBy,
                },
                Medicaid: {
                    Returned: this.Medicaid.Returned ?? "No",
                    VerifiedBy: this.Medicaid.VerifiedBy,
                },
                Insurance: {
                    Returned: this.Insurance.Returned ?? "No",
                    VerifiedBy: this.Insurance.VerifiedBy,
                },
                EBT: {
                    Returned: this.EBT.Returned ?? "No",
                    VerifiedBy: this.EBT.VerifiedBy,
                },
                Medication: {
                    Printed: this.Medication.Printed ?? "No",
                    VerifiedBy: this.Medication.VerifiedBy,
                },
                Doctors: {
                    Printed: this.Doctors.Printed ?? "No",
                    VerifiedBy: this.Doctors.VerifiedBy,
                },
                SocialAssessment: {
                    Printed: this.SocialAssessment.Printed ?? "No",
                    VerifiedBy: this.SocialAssessment.VerifiedBy,
                },
                Psych: {
                    Printed: this.Psych.Printed ?? "No",
                    VerifiedBy: this.Psych.VerifiedBy,
                },
                BehaviorPlan: {
                    Printed: this.BehaviorPlan.Printed ?? "No",
                    VerifiedBy: this.BehaviorPlan.VerifiedBy,
                },
                Account: {
                    Discharged: this.Account.Discharged ?? "No",
                    VerifiedBy: this.Account.VerifiedBy,
                },
                Shifts: {
                    Disabled: this.Shifts.Disabled ?? "No",
                    VerifiedBy: this.Shifts.VerifiedBy,
                },
                Pharmacy: {
                    Notified: this.Pharmacy.Notified ?? "No",
                    VerifiedBy: this.Pharmacy.VerifiedBy,
                },
                Inventory: {
                    Printed: this.Inventory.Printed ?? "No",
                    VerifiedBy: this.Inventory.VerifiedBy,
                },
                Meds: {
                    Discontinued: this.Meds.Discontinued ?? "No",
                    VerifiedBy: this.Meds.VerifiedBy,
                },
                ServicePlan: {
                    Deactivated: this.ServicePlan.Deactivated ?? "No",
                    VerifiedBy: this.ServicePlan.VerifiedBy,
                },
                Finance: {
                    Closed: this.Finance.Closed ?? "No",
                    VerifiedBy: this.Finance.VerifiedBy,
                },
                DayProgram: {
                    Notified: this.DayProgram.Notified ?? "No",
                    VerifiedBy: this.DayProgram.VerifiedBy,
                },
                School: {
                    Notified: this.School.Notified ?? "No",
                    VerifiedBy: this.School.VerifiedBy,
                },
                Staff: {
                    Notified: this.Staff.Notified ?? "No",
                    VerifiedBy: this.Staff.VerifiedBy,
                },
                Behaviorist: {
                    Notified: this.Behaviorist.Notified ?? "No",
                    VerifiedBy: this.Behaviorist.VerifiedBy,
                },
                Medical: {
                    Notified: this.Medical.Notified ?? "No",
                    VerifiedBy: this.Medical.VerifiedBy,
                },
                OutstandingInformation: this.OutstandingInformation,
                ClientServicesSignature: this.ClientServicesSignature,
                ComplianceSignature: this.ComplianceSignature,
            };

            try {
                const response = await  axios.put(`${url}/discharge/${this.dischargeID}`, req_body);
                if (response.status !== 200) {
                    displayError("An error occurred while updating the discharge record.");
                    return;
                }
                displaySuccess("The discharge record has been updated successfully.");
                this.getDischarges();
            } catch (error) {
             console.log(error);
            } finally {
                this.close();
            }
        },

        getDischarges() {
            this.isLoading = true;
            this.discharges = [];
            axios
                .get(`${url}/discharge/client/${this.clientID}`)
                .then((res) => {
                    this.discharges = res.data.discharges;
                })
                .finally(() => (this.isLoading = false));
        },

        getDischarge() {
            this.isLoading = true;
            axios.get(`${url}/discharge/${this.dischargeId}`)
                .then((res) => {
                    this.discharge = res.data.discharge;
                    this.viewDischarge(this.discharge);
                })
                .finally(() => (this.isLoading = false));
        },

        clear() {
            this.DischargeDate = "";
            this.Location = "";
            this.Identification.Returned = "";
            this.Identification.VerifiedBy = "";
            this.Social.Returned = "";
            this.Social.VerifiedBy = "";
            this.Medicaid.Returned = "";
            this.Medicaid.VerifiedBy = "";
            this.Insurance.Returned = "";
            this.Insurance.VerifiedBy = "";
            this.EBT.Returned = "";
            this.EBT.VerifiedBy = "";
            this.Medication.Printed = "";
            this.Medication.VerifiedBy = "";
            this.Doctors.Printed = "";
            this.Doctors.VerifiedBy = "";
            this.SocialAssessment.Printed = "";
            this.SocialAssessment.VerifiedBy = "";
            this.Psych.Printed = "";
            this.Psych.VerifiedBy = "";
            this.BehaviorPlan.Printed = "";
            this.BehaviorPlan.VerifiedBy = "";
            this.Account.Discharged = "";
            this.Account.VerifiedBy = "";
            this.Shifts.Disabled = "";
            this.Shifts.VerifiedBy = "";
            this.Pharmacy.Notified = "";
            this.Pharmacy.VerifiedBy = "";
            this.Inventory.Printed = "";
            this.Inventory.VerifiedBy = "";
            this.Meds.Discontinued = "";
            this.Meds.VerifiedBy = "";
            this.ServicePlan.Deactivated = "";
            this.ServicePlan.VerifiedBy = "";
            this.Finance.Closed = "";
            this.Finance.VerifiedBy = "";
            this.DayProgram.Notified = "";
            this.DayProgram.VerifiedBy = "";
            this.School.Notified = "";
            this.School.VerifiedBy = "";
            this.Staff.Notified = "";
            this.Staff.VerifiedBy = "";
            this.Behaviorist.Notified = "";
            this.Behaviorist.VerifiedBy = "";
            this.Medical.Notified = "";
            this.Medical.VerifiedBy = "";
            this.OutstandingInformation = "";
            this.ClientServicesSignature = "";
            this.ComplianceSignature = "";
            this.IDSigned = false;
            this.SocialSigned = false;
            this.MedicaidSigned = false;
            this.InsuranceSigned = false;
            this.EBTSigned = false;
            this.MedicationSigned = false;
            this.DoctorsSigned = false;
            this.SocialAssessmentSigned = false;
            this.PsychSigned = false;
            this.BehaviorPlanSigned = false;
            this.AccountSigned = false;
            this.ShiftsSigned = false;
            this.PharmacySigned = false;
            this.InventorySigned = false;
            this.MedsSigned = false;
            this.ServicePlanSigned = false;
            this.FinanceSigned = false;
            this.DayProgramSigned = false;
            this.SchoolSigned = false;
            this.StaffSigned = false;
            this.BehavioristSigned = false;
            this.MedicalSigned = false;
            this.ClientServicesSigned = false;
            this.ComplianceSigned = false;
            this.signed = false;
        },

        async addDischarge() {
            let req_body = {
                DischargeDate: this.DischargeDate,
                ClientID: this.clientID,
                Location: this.Location,
                Identification: {
                    Returned: this.Identification.Returned,
                    VerifiedBy: this.Identification.VerifiedBy,
                },
                Social: {
                    Returned: this.Social.Returned,
                    VerifiedBy: this.Social.VerifiedBy,
                },
                Medicaid: {
                    Returned: this.Medicaid.Returned,
                    VerifiedBy: this.Medicaid.VerifiedBy,
                },
                Insurance: {
                    Returned: this.Insurance.Returned,
                    VerifiedBy: this.Insurance.VerifiedBy,
                },
                EBT: {
                    Returned: this.EBT.Returned,
                    VerifiedBy: this.EBT.VerifiedBy,
                },
                Medication: {
                    Printed: this.Medication.Printed,
                    VerifiedBy: this.Medication.VerifiedBy,
                },
                Doctors: {
                    Printed: this.Doctors.Printed,
                    VerifiedBy: this.Doctors.VerifiedBy,
                },
                SocialAssessment: {
                    Printed: this.SocialAssessment.Printed,
                    VerifiedBy: this.SocialAssessment.VerifiedBy,
                },
                Psych: {
                    Printed: this.Psych.Printed,
                    VerifiedBy: this.Psych.VerifiedBy,
                },
                BehaviorPlan: {
                    Printed: this.BehaviorPlan.Printed,
                    VerifiedBy: this.BehaviorPlan.VerifiedBy,
                },
                Account: {
                    Discharged: this.Account.Discharged,
                    VerifiedBy: this.Account.VerifiedBy,
                },
                Shifts: {
                    Disabled: this.Shifts.Disabled,
                    VerifiedBy: this.Shifts.VerifiedBy,
                },
                Pharmacy: {
                    Notified: this.Pharmacy.Notified,
                    VerifiedBy: this.Pharmacy.VerifiedBy,
                },
                Inventory: {
                    Printed: this.Inventory.Printed,
                    VerifiedBy: this.Inventory.VerifiedBy,
                },
                Meds: {
                    Discontinued: this.Meds.Discontinued,
                    VerifiedBy: this.Meds.VerifiedBy,
                },
                ServicePlan: {
                    Deactivated: this.ServicePlan.Deactivated,
                    VerifiedBy: this.ServicePlan.VerifiedBy,
                },
                Finance: {
                    Closed: this.Finance.Closed,
                    VerifiedBy: this.Finance.VerifiedBy,
                },
                DayProgram: {
                    Notified: this.DayProgram.Notified,
                    VerifiedBy: this.DayProgram.VerifiedBy,
                },
                School: {
                    Notified: this.School.Notified,
                    VerifiedBy: this.School.VerifiedBy,
                },
                Staff: {
                    Notified: this.Staff.Notified,
                    VerifiedBy: this.Staff.VerifiedBy,
                },
                Behaviorist: {
                    Notified: this.Behaviorist.Notified,
                    VerifiedBy: this.Behaviorist.VerifiedBy,
                },
                Medical: {
                    Notified: this.Medical.Notified,
                    VerifiedBy: this.Medical.VerifiedBy,
                },
                OutstandingInformation: this.OutstandingInformation,
                ClientServicesSignature: this.ClientServicesSignature,
                ComplianceSignature: this.ComplianceSignature,
            };

            try {
                const response = await axios.post(`${url}/discharge`, req_body);

                if (response.status !== 200) {
                    displayError("An error occurred while adding the client discharge. Please try again.");
                    return;
                }
                displaySuccess("Client discharge added successfully.");
                this.getDischarges();

            } catch (error) {
                console.log(error);
            } finally {
                this.close();
            }
        },

        addIDSignature: function () {
            if (!this.IDSigned) {
                return (this.Identification.VerifiedBy = "");
            }
            this.Identification.VerifiedBy = this.staff + " - " + new Date();
            this.IDSigned = true;
        },

        addSocialSignature: function () {
            if (!this.SocialSigned) {
                return (this.Social.VerifiedBy = "");
            }
            this.Social.VerifiedBy = this.staff + " - " + new Date();
            this.SocialSigned = true;
        },

        addMedicaidSignature: function () {
            if (!this.MedicaidSigned) {
                return (this.Medicaid.VerifiedBy = "");
            }
            this.Medicaid.VerifiedBy = this.staff + " - " + new Date();
            this.MedicaidSigned = true;
        },

        addInsuranceSignature: function () {
            if (!this.InsuranceSigned) {
                return (this.Insurance.VerifiedBy = "");
            }
            this.Insurance.VerifiedBy = this.staff + " - " + new Date();
            this.InsuranceSigned = true;
        },

        addEBTSignature: function () {
            if (!this.EBTSigned) {
                return (this.EBT.VerifiedBy = "");
            }
            this.EBT.VerifiedBy = this.staff + " - " + new Date();
            this.EBTSigned = true;
        },

        addMedicationSignature: function () {
            if (!this.MedicationSigned) {
                return (this.Medication.VerifiedBy = "");
            }
            this.Medication.VerifiedBy = this.staff + " - " + new Date();
            this.MedicationSigned = true;
        },

        addDoctorsSignature: function () {
            if (!this.DoctorsSigned) {
                return (this.Doctors.VerifiedBy = "");
            }
            this.Doctors.VerifiedBy = this.staff + " - " + new Date();
            this.DoctorsSigned = true;
        },

        addSocialAssessmentSignature: function () {
            if (!this.SocialAssessmentSigned) {
                return (this.SocialAssessment.VerifiedBy = "");
            }
            this.SocialAssessment.VerifiedBy = this.staff + " - " + new Date();
            this.SocialAssessmentSigned = true;
        },

        addPsychSignature: function () {
            if (!this.PsychSigned) {
                return (this.Psych.VerifiedBy = "");
            }
            this.Psych.VerifiedBy = this.staff + " - " + new Date();
            this.PsychSigned = true;
        },

        addBehaviorPlanSignature: function () {
            if (!this.BehaviorPlanSigned) {
                return (this.BehaviorPlan.VerifiedBy = "");
            }
            this.BehaviorPlan.VerifiedBy = this.staff + " - " + new Date();
            this.BehaviorPlanSigned = true;
        },

        addAccountSignature: function () {
            if (!this.AccountSigned) {
                return (this.Account.VerifiedBy = "");
            }
            this.Account.VerifiedBy = this.staff + " - " + new Date();
            this.AccountSigned = true;
        },

        addShiftSignature: function () {
            if (!this.ShiftsSigned) {
                return (this.Shifts.VerifiedBy = "");
            }
            this.Shifts.VerifiedBy = this.staff + " - " + new Date();
            this.ShiftsSigned = true;
        },

        addPharmacySignature: function () {
            if (!this.PharmacySigned) {
                return (this.Pharmacy.VerifiedBy = "");
            }
            this.Pharmacy.VerifiedBy = this.staff + " - " + new Date();
            this.PharmacySigned = true;
        },

        addInventorySignature: function () {
            if (!this.InventorySigned) {
                return (this.Inventory.VerifiedBy = "");
            }
            this.Inventory.VerifiedBy = this.staff + " - " + new Date();
            this.InventorySigned = true;
        },

        addMedsSignature: function () {
            if (!this.MedsSigned) {
                return (this.Meds.VerifiedBy = "");
            }
            this.Meds.VerifiedBy = this.staff + " - " + new Date();
            this.MedsSigned = true;
        },

        addServicePlanSignature: function () {
            if (!this.ServicePlanSigned) {
                return (this.ServicePlan.VerifiedBy = "");
            }
            this.ServicePlan.VerifiedBy = this.staff + " - " + new Date();
            this.ServicePlanSigned = true;
        },

        addFinanceSignature: function () {
            if (!this.FinanceSigned) {
                return (this.Finance.VerifiedBy = "");
            }
            this.Finance.VerifiedBy = this.staff + " - " + new Date();
            this.FinanceSigned = true;
        },

        addDayProgramSignature: function () {
            if (!this.DayProgramSigned) {
                return (this.DayProgram.VerifiedBy = "");
            }
            this.DayProgram.VerifiedBy = this.staff + " - " + new Date();
            this.DayProgramSigned = true;
        },

        addSchoolSignature: function () {
            if (!this.SchoolSigned) {
                return (this.School.VerifiedBy = "");
            }
            this.School.VerifiedBy = this.staff + " - " + new Date();
            this.SchoolSigned = true;
        },

        addStaffSignature: function () {
            if (!this.StaffSigned) {
                return (this.Staff.VerifiedBy = "");
            }
            this.Staff.VerifiedBy = this.staff + " - " + new Date();
            this.StaffSigned = true;
        },

        addBehavioristSignature: function () {
            if (!this.BehavioristSigned) {
                return (this.Behaviorist.VerifiedBy = "");
            }
            this.Behaviorist.VerifiedBy = this.staff + " - " + new Date();
            this.BehavioristSigned = true;
        },

        addMedicalSignature: function () {
            if (!this.MedicalSigned) {
                return (this.Medical.VerifiedBy = "");
            }
            this.Medical.VerifiedBy = this.staff + " - " + new Date();
            this.MedicalSigned = true;
        },

        addClientServicesSignature: function () {
            if (!this.ClientServicesSigned) {
                return (this.ClientServicesSignature = "");
            }
            this.ClientServicesSignature = this.staff + " - " + new Date();
            this.ClientServicesSigned = true;
        },

        addComplianceSignature: function () {
            if (!this.ComplianceSigned) {
                return (this.ComplianceSignature = "");
            }
            this.ComplianceSignature = this.staff + " - " + new Date();
            this.ComplianceSigned = true;
        },

        async generateDownloadUrl() {
            return `${url}/discharge/print?id=${this.dischargeId}`;
        },

        async showPrintModal() {
            this.downloadUrl = await this.generateDownloadUrl();
            PrintUtil.showPrintOption(this.downloadUrl, this.dischargeId, this.token,'Discharge');
        },
    },
};
</script>
<style>
@media only screen and (min-width: 768px) {
    .mobile {
        display: none;
    }
}

@media only screen and (max-width: 600px) {
    .desktop {
        display: none;
    }
}
</style>
